import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "section"]
  static classes = ["active"]

  connect() {
    this.visible = new Map()
    this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), {
      rootMargin: "-20% 0px -65% 0px",
      threshold: [0, 0.25, 0.6]
    })
    this.sectionTargets.forEach((section) => this.observer.observe(section))
    if (this.linkTargets[0]) this.activate(this.idFromHref(this.linkTargets[0]))
  }

  disconnect() {
    this.observer?.disconnect()
  }

  go(event) {
    const id = this.idFromHref(event.currentTarget)
    const el = document.getElementById(id)
    if (!el) return

    event.preventDefault()
    el.scrollIntoView({ behavior: this.motion(), block: "start" })
    history.replaceState(null, "", `#${id}`)

    const section = el.matches("[data-scroll-spy-target='section']")
      ? el
      : el.closest("[data-scroll-spy-target='section']")
    this.activate(section?.id || id)
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) this.visible.set(entry.target.id, entry)
      else this.visible.delete(entry.target.id)
    })
    if (this.visible.size === 0) return

    const topmost = [...this.visible.values()].sort(
      (a, b) => a.boundingClientRect.top - b.boundingClientRect.top
    )[0]
    this.activate(topmost.target.id)
  }

  activate(id) {
    if (!id || this.activeId === id) return
    this.activeId = id

    this.linkTargets.forEach((link) => {
      const on = this.idFromHref(link) === id
      link.classList.toggle(this.activeClass, on)
      if (on) {
        link.scrollIntoView({ inline: "center", block: "nearest", behavior: this.motion() })
      }
    })
  }

  idFromHref(link) {
    return (link.getAttribute("href") || "").replace(/^#/, "")
  }

  motion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
  }
}
